// extracted by mini-css-extract-plugin
export default {"main":"home_main__hEx5t","title":"home_title__HV-cF","input":"home_input__LqwqF","image":"home_image__J4BWK","footer":"home_footer__bfuH9"};